// extracted by mini-css-extract-plugin
export default {"RevisionDateCell":"RevisionDateCell_RevisionDateCell__FPwRb","RevisionWarning":"RevisionDateCell_RevisionWarning__9gAvP"};